import Vue from 'vue';
import noty from './noty.service';

export default {
  async getSettingsByClient(clientId) {
    return (await Vue.http.get(`/api/flg/settings/byclient/${clientId}`)).data;
  },
  async save(clientId, flgSettings) {
    await Vue.http.post(`/api/flg/settings/byclient/${clientId}`, flgSettings);
    noty.success('Settings saved successfully');
  }
}



// WEBPACK FOOTER //
// ./src/services/flg.service.js